import AccountsReceivableSettlement from 'models/accounts-receivable-settlement'
import CurrencyMinxins from "common/mixins/currency";
export default {
  mixins: [CurrencyMinxins],
  data() {
    return {
      // 出仓单状态选择索引
      activeExitWarehouseStatusIndex: 0,
      // 出仓单状态
      exitWarehouseStatus: null,
      exitWarehouseTableData: [],
      // 出仓单所有数据
      exitWarehouseCodeList: [],
      exitWarehouseCheckAll: false,
      // 选中的数据
      checkedExitWarehouseCodeList: [],
      exitWarehouseIsIndeterminate: false,
      activeExitWarehouseCode: '',
    }
  },
  created() {
  },
  methods: {
    // 出仓列表
    initExitWarehouseTable() {
      let projectId = this.screen.projectId;
      let projectName = this.screen.projectName;
      let balanceBeginDate = this.screen.date ? this.screen.date[0] : '';
      let balanceEndDate = this.screen.date ? this.screen.date[1] : '';
      let currency = this.screen.currencySystem;
      let data = {
        projectId,
        projectName,
        balanceBeginDate,
        balanceEndDate,
        currency
      }
      AccountsReceivableSettlement.getExitWarehouseList(data).then(res => {
        if (res.success) {
          let exitWarehouseCodeList = [];
          res.result.map((i, index) => {
            let obj = {}
            obj.id = index+1
            obj.code = i.orderNo
            obj.outboundOrderNo = i.outboundOrderNo
            obj.amount = i.amount
            obj.checked = false
            obj.subjectList = []
            i.feeList.map(v => {
              if (!v.orderFeeId) throw new Error(`费用明细缺少orderFeeId，出仓单号：${i.orderNo}，费用名称：${v.feeName}`)
              let obj3 = {}
              obj3.id = v.keyword;
              obj3.keyId = `${i.orderNo}-${v.orderFeeId}`;
              obj3.isSelect = false;
              obj3.feeName = v.feeName;
              obj3.isAddService = v.isAddService;
              obj3.orderFeeId = v.orderFeeId;
              obj3.agentBusiness = v.agentBusiness;
              obj3.agentBusinessVal = v.agentBusiness ? '是' : '否';
              obj3.billHeadId = v.billHeadId;
              obj3.billHeadName = v.billHead ? `${v.billHead.name} ${v.billHead.code}` : '';
              obj3.currency = v.currency;
              obj3.currencyVal = this.currencySystemObj[v.currency];
              obj3.amount = v.price;
              obj3.status = v.isBalance ? 2 : 1;
              obj3.statusVal = !v.isBalance ? '未结算' : '已结算';
              obj.subjectList.push(obj3)
            })
            exitWarehouseCodeList.push(obj)
          })
          this.exitWarehouseCodeList = exitWarehouseCodeList
          this.exitWarehouseIsIndeterminate = false;
          this.exitWarehouseTableData = []
          this.checkedExitWarehouseCodeList = []
          this.initTotalAccountsReceivable()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 应付出仓列表
    initPayExitWarehouseTable() {
      let projectId = this.screen.projectId;
      let billHeadId = this.screen.lookUpId;
      let balanceBeginDate = this.screen.date ? this.screen.date[0] : '';
      let balanceEndDate = this.screen.date ? this.screen.date[1] : '';
      let currency = this.screen.currencySystem;
      let data = {
        projectId,
        billHeadId,
        balanceBeginDate,
        balanceEndDate,
        currency
      }
      AccountsReceivableSettlement.getPayExitWarehouseList(data).then(res => {
        if (res.success) {
          let exitWarehouseCodeList = [];
          res.result.map((i, index) => {
            let obj = {}
            obj.id = index+1
            obj.code = i.orderNo
            obj.outboundOrderNo = i.outboundOrderNo
            obj.amount = i.amount
            obj.checked = false
            obj.subjectList = []
            i.feeList.map(v => {
              if (!v.orderFeeId) throw new Error(`费用明细缺少orderFeeId，出仓单号：${i.orderNo}，费用名称：${v.feeName}`)
              let obj3 = {}
              obj3.id = v.keyword;
              obj3.keyId = `${i.orderNo}-${v.orderFeeId}`;
              obj3.isSelect = false;
              obj3.feeName = v.feeName;
              obj3.projectId = v.projectId;
              obj3.projectName = v.projectName;
              obj3.isAddService = v.isAddService;
              obj3.orderFeeId = v.orderFeeId;
              obj3.agentBusiness = v.agentBusiness;
              obj3.agentBusinessVal = v.agentBusiness ? '是' : '否';
              obj3.billHeadId = v.billHeadId;
              obj3.billHeadName = v.billHead ? `${v.billHead.name} ${v.billHead.code}` : '';
              obj3.currency = v.currency;
              obj3.currencyVal = this.currencySystemObj[v.currency];
              obj3.amount = v.price;
              obj3.status = v.isBalance ? 2 : 1;
              obj3.statusVal = !v.isBalance ? '未结算' : '已结算';
              obj.subjectList.push(obj3)
            })
            exitWarehouseCodeList.push(obj)
          })
          this.exitWarehouseCodeList = exitWarehouseCodeList
          this.exitWarehouseIsIndeterminate = false;
          this.exitWarehouseTableData = []
          this.checkedExitWarehouseCodeList = []
          this.initTotalAccountsReceivable()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 初始化出仓数据
    initExitData() {
      this.activeExitWarehouseStatusIndex = 0
      this.exitWarehouseStatus = null
      this.exitWarehouseTableData = []
      this.exitWarehouseCodeList = []
      this.exitWarehouseCheckAll = false
      this.checkedExitWarehouseCodeList = []
      this.exitWarehouseIsIndeterminate = false
      this.activeExitWarehouseCode = ''
    },
    changeExitWarehouseCode(row) {
      row.checked = !row.checked
      this.activeExitWarehouseCode = row.code
      row.subjectList.map(i => {
        if (i.status !== 2) i.isSelect = row.checked
      })
      this.exitWarehouseTableData = row.checked ? row.subjectList : []
      if (!row.checked) {
        this.$nextTick(() => {
          this.$refs.exitWarehouseMultipleTable.clearSelection();
        })
      }
      this.exitWarehouseTableData.map(i => {
        if (i.isSelect) {
          this.$nextTick(() => {
            this.$refs.exitWarehouseMultipleTable.toggleRowSelection(i, true);
          })
        } else {
          this.$nextTick(() => {
            this.$refs.exitWarehouseMultipleTable.toggleRowSelection(i, false);
          })
        }
      })
      this.initCheckedExitWarehouseCodeList()
    },

    exitWarehouseSelectAll() {
      if (!this.exitWarehouseTableData.length) this.$refs.exitWarehouseMultipleTable.clearSelection();
    },

    // 选择进仓结算状态
    selectExitWarehouseStatus(row, index) {
      this.activeExitWarehouseStatusIndex = index
      this.exitWarehouseStatus = row.id
    },
    exitWarehouseCheckSelectable(row) {
      if (row.status === 2) {
        return false
      } else {
        return true
      }
    },
    // 进仓单全选
    handleExitWarehouseCheckAllChange(val) {
      this.exitWarehouseCodeList.map(i => {
        i.checked = val
        i.subjectList.map(j => {
          if (j.status !== 2) j.isSelect = val
        })
      })
      this.checkedExitWarehouseCodeList = val ? this.exitWarehouseCodeList : [];
      this.exitWarehouseIsIndeterminate = false;

      if (this.activeExitWarehouseCode) {
        let obj = this.exitWarehouseCodeList.find(item => { return item.code === this.activeExitWarehouseCode })
        this.exitWarehouseTableData = obj.subjectList
        this.exitWarehouseTableData.map(i => {
          if (i.isSelect) {
            this.$nextTick(() => {
              this.$refs.exitWarehouseMultipleTable.toggleRowSelection(i, true);
            })
          } else {
            this.$nextTick(() => {
              this.$refs.exitWarehouseMultipleTable.toggleRowSelection(i, false);
            })
          }
        })
      }
      this.initTotalAccountsReceivable()
    },
    /** 
     * @description 获取选中的进仓单数据
    */
    initCheckedExitWarehouseCodeList() {
      let checkedExitWarehouseCodeList = []
      this.exitWarehouseCodeList.map(i => {
        if (i.checked) checkedExitWarehouseCodeList.push(i)
      })
      this.checkedExitWarehouseCodeList = checkedExitWarehouseCodeList
      this.exitWarehouseCheckAll = this.exitWarehouseCodeList.length === checkedExitWarehouseCodeList.length
      this.exitWarehouseIsIndeterminate = checkedExitWarehouseCodeList.length > 0 && checkedExitWarehouseCodeList.length < this.exitWarehouseCodeList.length;
      this.$nextTick(() => {
        this.initTotalAccountsReceivable()
      })
    },
    /* 修改exitWarehouseCodeList里所选中的数据 */
    async handleSelectionChange(val) {
      await this.exitWarehouseCodeList.map(async j => {
        if (j.code === this.activeExitWarehouseCode) {
          // 未结算的出仓单数量
          await j.subjectList.map(async c => {
            c.isSelect = await false
            await val.map(async i => {
              if (c.keyId === i.keyId) {
                c.isSelect = await true
              }
            })
          })
        }
      })
      this.initCheckedExitWarehouseCodeList()
    }
  }
}